export const REGION_INTERVAL_DURATION = 10_000;

export const PADDING_Y = 75;

export type RegionId = 'global' | 'japan' | 'uk' | 'north-america';

export type MapRegionConfig = {
  highlightedCountryNames?: string[];
  id: RegionId;
};

export const COUNTRY_NAMES = {
  Antarctica: 'Antarctica',
  Canada: 'Canada',
  Japan: 'Japan',
  UnitedStatesOfAmerica: 'United States of America',
  UnitedKingdom: 'United Kingdom',
};

const UK: MapRegionConfig = {
  highlightedCountryNames: [COUNTRY_NAMES.UnitedKingdom],
  id: 'uk',
};

const globalConfig: MapRegionConfig = {
  highlightedCountryNames: [
    COUNTRY_NAMES.UnitedStatesOfAmerica,
    COUNTRY_NAMES.UnitedKingdom,
    COUNTRY_NAMES.Japan,
    COUNTRY_NAMES.Canada,
  ],
  id: 'global',
};

const japanConfig: MapRegionConfig = {
  highlightedCountryNames: [COUNTRY_NAMES.Japan],
  id: 'japan',
};

const northAmericaConfig: MapRegionConfig = {
  highlightedCountryNames: [
    COUNTRY_NAMES.UnitedStatesOfAmerica,
    COUNTRY_NAMES.Canada,
  ],
  id: 'north-america',
};

export const configs: MapRegionConfig[] = [
  globalConfig,
  northAmericaConfig,
  UK,
  japanConfig,
];
